"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCodeOfConduct = function IconCodeOfConduct(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M36 5v11h-2V7H12v31a3 3 0 0 0 2.824 2.995L15 41h17v2H15a5 5 0 0 1-4.995-4.783L10 38V5zm-5 6.97v-1H15v1zm0 3v1H15v-1zm-8 4v1h-8v-1zm-1.864 11.905a1.64 1.64 0 0 0-1.763.061l-.089.069-3.73 3.24 1.312 1.51 2.986-2.596-.017.17v.156c.027.616.345 1.128.844 1.403l.138.068a1.64 1.64 0 0 0 1.576-.15l.607-.505.006.16a1.64 1.64 0 0 0 1.634 1.499H30v-2h-5v-.47l-.016-.16a1.64 1.64 0 0 0-.901-1.274l-.147-.064a1.64 1.64 0 0 0-1.5.182l-.518.43.017-.153.008-.146a1.64 1.64 0 0 0-.807-1.43M39 17.97v20.19l-3.027 3.297L33 38.154V17.97zm-2 4v-2h-2v2zm0 2v13.409l-1.013 1.104L35 37.387V23.97z",
    clipRule: "evenodd"
  })));
};

export { IconCodeOfConduct, IconCodeOfConduct as default };
